/**************************************************
 * Nombre:       Producto_Detalles
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import Tarjeta_Variante from "../../../Tarjetas/Tarjeta_Variante";
import {FiberManualRecord, ShoppingCartOutlined} from '@mui/icons-material'
import {useCarritoFlotante} from "../../../../Modulo_Carrito_Flotante/Hooks/useCarritoFlotante";
import logos from '../../../../Recursos/logos.png'
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";


const Producto_Detalles = ({item}) => {
    const {sCell, masSM} = useResponsive()
    const {Carrito, abrir} = useCarritoFlotante()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{px: 2}}
        >

            <Carrito/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 4}}>
                <Typography sx={{fontSize: 14, color: "#00000090"}}>{item?.marca}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 0}}>
                <Typography
                    sx={{fontSize: !masSM ? 24 : 32, color: "#000000", fontWeight: 700, lineHeight: 1.1}}>{item?.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: 16, color: "#000000"}}>
                    {item?.descripcion}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                <Typography sx={{fontSize: 16, color: theme.palette.primary.main, fontWeight: 700}}>
                    Mezcalero:

                    <span style={{marginLeft: 5, fontWeight: 500}}>
                   {item?.mezcalero}
                     </span>
                </Typography>

            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{mt: 4}}
            >

                {item && item.variantes && item?.variantes.map((it, index) => {
                    return (
                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Tarjeta_Variante item={it} producto={item}/>
                        </Grid>


                    )
                })}

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Button
                        onClick={() => abrir()}
                        fullWidth sx={{height: 60}}
                        startIcon={<ShoppingCartOutlined/>}
                    >
                        Ir al Carrito
                    </Button>
                </Grid>

            </Grid>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={0}
                sx={{mt: 4}}
            >

                {item && item.adicionales && item.adicionales.map((it, index) => {
                    return (
                        <Typography sx={{color: '#00000090'}}>
                            <FiberManualRecord sx={{width: 10, height: 10, px: 1}}/>
                            {it}
                        </Typography>
                    )
                })}

            </Grid>



        </Grid>
    )

}
export default Producto_Detalles

